import { PackType } from "@is/constants";

import { ProductItem, SearchTerm, SearchTermType } from "./style";

export enum ContentItemType {
  ProductDetailsItem = "ProductDetailsItem",
  WidgetItem = "WidgetItem",
  ContentWidgetItem = "ContentWidgetItem",
  ProductRow = "ProductRow",
  HowToWearIt = "HowToWearIt",
}

export enum WidgetType {
  SimilarProducts = "SimilarProducts",
  CompleteLook = "CompleteLook",
  ShopLook = "ShopLook",
  AllColors = "AllColors",
  HowAboutThese = "HowAboutThese",
  AllItems = "AllItems",
  Collection = "Collection",
  HowToWearIt = "HowToWearIt",
}

export type DefaultContentWidget = {
  id: string;
  type: WidgetType;
  title: string;
  isClosed: boolean;
  isExpanded: boolean;
  showAllItems: boolean;
  items: ProductItem[];
  customSubtitle?: string;
};

export type HTWIContentWidget = {
  id: string;
  type: WidgetType.HowToWearIt;
  title: string;
  isClosed: boolean;
  isExpanded: boolean;
  showAllItems: boolean;
  items: HowToWearItWidget[];
  customSubtitle?: string;
};

export type WidgetItem = DefaultContentWidget | HTWIContentWidget;

export type ProductContentItem = {
  type: ContentItemType.ProductDetailsItem;
  id: string;
  content: ProductItem;
};

export type WidgetContentItem = {
  type: ContentItemType.WidgetItem | ContentItemType.ContentWidgetItem;
  id: string;
  content: WidgetItem;
};

export type ProductRowContentItem = {
  type: ContentItemType.ProductRow;
  id: string;
  isBestMatch: boolean;
  content: ProductItem[];
};

export type HowToWearIt = {
  modelShotUrl?: string;
  name?: string;
  description?: string;
  items: { type: PackType; url: string }[];
};

export type HTWIMedia = {
  id: string;
  variantId: string;
  styleId: string;
  packType: PackType;
  url: string;
};

export type HowToWearItWidget = {
  modelShotUrl?: string;
  name?: string;
  description?: string;
  items: ProductItem[];
  media: HTWIMedia[];
  mainStyle?: ProductItem;
};

export type HowToWearItItem = {
  modelShotUrl?: string;
  name?: string;
  description?: string;
  items: ProductItem[];
};

export type HowToWearItContentItem = {
  type: ContentItemType.HowToWearIt;
  id: string;
  content: HowToWearIt[];
};

export type ContentItem =
  | ProductContentItem
  | WidgetContentItem
  | ProductRowContentItem
  | HowToWearItContentItem;

export type SuggestionItem = {
  key?: string;
  filterKey: string;
  label: string;
  value?: string;
  type: SearchTermType;
};

export type Section = {
  searchTerms: SearchTerm[];
  items: ContentItem[];
  id: string;
  page: number;
  totalCount: number;
  notViewedItems: ContentItem[];
  hasNextPage: boolean;
};

export type SearchFunctionProperties = {
  newSearchTerms?: SearchTerm[];
  pageNumber?: number;
  sectionId?: string;
  enableFocusedItem?: boolean;
  showDrawers?: boolean;
  newSections?: Section[] | null;
};

export enum MediaOrderingRule {
  MediaSlider = "mediaSlider",
  Widget = "widget",
  ColorThumbnails = "colorThumbnails",
}
